import { render, staticRenderFns } from "./LibraryPreview.vue?vue&type=template&id=3bedc866&"
import script from "./LibraryPreview.vue?vue&type=script&lang=js&"
export * from "./LibraryPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports